function addToCart(id){
    jQuery.post('/cart/add.js', {
        quantity: 1,
        id: id
    });
    console.log(id);
    var cart=jQuery.get('/cart.js');
    
    $('.cartItemCount').html(cart.item_count);


 
 
  	
}
